<template>

    <div class="index background relative">

        <div class="about-top"></div>

        <div class="about-content cf">

            <div class="fl contact-info">

                <div class="contact-name bold">{{ data.company_name }}</div>

                <div
                    class="contact-floor cf"
                    v-for="(item,index) in list"
                    :key="'contact-floor-'+index"
                >

                    <img class="fl" :src="item.icon"/>

                    <div class="fl">{{ item.label }}：{{ data[item.key] }}</div>

                </div>

            </div>

            <div class="fr contact-map">

                <baidu-map
                    :center="data.address"
                    :zoom="zoom"
                    :scroll-wheel-zoom="true"
                    style="height:100%"
                    @ready="handler"
                >

                    <bm-marker :position="center"></bm-marker>

                </baidu-map>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "contact",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
